import {loginApi , getStudentInfoApi} from '@/api/login'
import {getLocalStorage,setLocalStorage,setToken} from '@/utils/auth'
// import { updateUserInfoApi , getUserInfoApi } from '@/api/user';

const user = {
	state: {
		userInfo: '',
		hasLogin: false,
		perms: [],
		token:'',
		path:'',
		rem:'',
	},
	
	mutations: {
		SET_USERINFO: (state, userInfo) => {
			state.userInfo = userInfo
		},
		SET_PERMS: (state, perms) => {
			state.perms = perms
		},
		SET_HASLOGIN: (state, hasLogin) => {
			state.hasLogin = hasLogin
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		}
	},
	
	actions: {
		loginByUsername({ commit }, userInfo) {
			console.log('buss')
			return new Promise((resolve, reject)=>{
				loginApi(userInfo).then(res=>{
					console.log(res)
					resolve()
					// if(res&&res.result){
					// 	// const perms = res.result.permission
					// 	commit('SET_USERINFO', res.result)
					// 	commit('SET_TOKEN', res.result.token)
					// 	// commit('SET_PERMS', perms)
					// 	commit('SET_HASLOGIN', true)
					// 	setLocalStorage(res.result)
					// 	setToken(res.result.token)
					// 	resolve()
					// }
				}).catch(error=>{
					reject(error)
				})
			})
		},
		
		updateUserInfo({commit,state}) {
			// return new Promise((resolve,reject)=>{
			const userInfo = getLocalStorage()
			if(userInfo){
				commit('SET_USERINFO', userInfo)
				// commit('SET_PERMS', userInfo.permission)
				commit('SET_HASLOGIN', true)
				// resolve()
			}
			// })
		},
		
		getStudentInfoApi({commit,state}) {
			return new Promise((resolve, reject)=>{
				getStudentInfoApi().then(res=>{
					if(res&&res.result){
						// const perms = res.result.permission
						commit('SET_USERINFO', res.result)
						// commit('SET_PERMS', perms)
						commit('SET_HASLOGIN', true)
						setLocalStorage(res.result)
						resolve()
					}
				}).catch(error=>{
					reject(error)
				})
			})
		},
		
		logOutFn({commit,state}){
			commit('SET_HASLOGIN', false)
			commit('SET_USERINFO', '')
			commit('SET_TOKEN', '')
			window.localStorage.setItem('userInfo','')
			window.localStorage.setItem('token','')
		},
		
	},
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js